!(function () {
  const o = (e) => {
      if (e) {
        var s = e.parentNode.parentNode.querySelector(
            '.products-with-tabs__navigation'
          ),
          r = e.querySelector('.products-with-tabs__pagination'),
          a = Number(e.dataset.columns),
          i = 5 == a ? a - 1 : a,
          o = 3 < a ? i - 1 : i,
          c = 2 < a ? o - 1 : o;
        let t = 1;
        e.classList.contains('products--2-mobile') && (t = 1 < a ? 2 : 1),
          new Swiper(e, {
            slidesPerView: (window.innerWidth <= 575) && (e.querySelector('.products-with-tabs__pagination').dataset.peekOnMobile === 'true') ? 1.75 : t,
            spaceBetween: (window.innerWidth <= 575) && (e.querySelector('.products-with-tabs__pagination').dataset.peekOnMobile === 'true') ? 0 : 8,
            slidesPerGroup: (window.innerWidth <= 575) && (e.querySelector('.products-with-tabs__pagination').dataset.peekOnMobile === 'true') ? 1 : t,
            navigation: {
              nextEl: s.querySelector('.swiper-button-next'),
              prevEl: s.querySelector('.swiper-button-prev'),
            },
            pagination: {
              el: r,
              type: 'custom',
              clickable: !0,
              renderCustom: function (t, e, s) {
                let r = '';
                for (let t = 1; t < s + 1; t++)
                  r =
                    t == e
                      ? `${r}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${t}"></span>`
                      : `${r}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${t}"></span>`;
                return r;
              },
            },
            breakpoints: {
              576: { slidesPerView: c, slidesPerGroup: c, spaceBetween: 24 },
              750: { slidesPerView: o, slidesPerGroup: o, spaceBetween: 24 },
              1200: { slidesPerView: i, slidesPerGroup: i, spaceBetween: 24 },
              1600: { slidesPerView: a, slidesPerGroup: a, spaceBetween: 24 },
            },
          });
      }
    },
    c = (t) => {
      t &&
        t.querySelectorAll('.products-with-tabs__slider').forEach((t) => {
          t.swiper && t.swiper.destroy();
        });
    },
    e = (a) => {
      if (a && a.classList.contains('products-with-tabs-section')) {
        const i = a.querySelectorAll('.products-with-tabs__tab');
        i.forEach((s) => {
          const r = s.dataset.productTab;
          s.addEventListener('click', (t) => {
            var e;
            t.currentTarget.classList.contains('button--secondary') ||
              (i.forEach((t) => {
                t.classList.remove('button--secondary'),
                  t.classList.add('button--tertiary');
              }),
              s.classList.remove('button--tertiary'),
              s.classList.add('button--secondary'),
              (t = a),
              (e = r),
              t &&
                (t
                  .querySelectorAll('.products-with-tabs__products')
                  .forEach((t) => {
                    t.classList.remove('products-with-tabs__products--active');
                  }),
                c(t),
                (t = t.querySelector(
                  `[data-product-tab="${e}"].products-with-tabs__products`
                ))) &&
                (t.classList.add('products-with-tabs__products--active'),
                t.classList.contains('products-with-tabs__slider')) &&
                o(t));
          });
        });
      }
    },
    s = (t) => {
      t &&
        t.classList.contains('products-with-tabs-section') &&
        (t = t.querySelector(
          '.products-with-tabs__slider.products-with-tabs__products--active'
        )) &&
        o(t);
    };
  s(document.currentScript.parentElement),
    e(document.currentScript.parentElement),
    document.addEventListener('shopify:section:load', function (t) {
      s(t.target), e(t.target);
    });
})();
